import ChartType from '@opsbase/lib-chart/ChartType';
import ChartVariant from '@opsbase/lib-chart/ChartVariant';
import QFK from '@opsbase/lib-data-queryfield/QueryFieldKey';
import DataType from '@opsbase/lib-datatype/DataType';
import i18n from '@opsbase/lib-i18n';
import Palette from '@opsbase/lib-palette';
import useOpDefinitionIssueCount from '@opsbase/react-gql-hooks/opdefinition/useOpDefinitionIssueCount';
import Pie2D from '@opsbase/web-charts/Pie2D';
import useViewRegistry from '@opsbase/web-ctrl-view/useViewRegistry';
import Card from '@opsbase/web-layout/Card';
import Pane from '@opsbase/web-layout/Pane';
import Vertical from '@opsbase/web-layout/Vertical';
import Dots from '@opsbase/web-ui/Dots';
import Text from '@opsbase/web-ui/Text';
import random from 'lodash/random';
import range from 'lodash/range';
import React, { useMemo } from 'react';
import DashboardWidgetViewer from '../../../../shared/UX/DashboardWidgetViewer';
export function IssuesOverviewSection(props) {
    const { opDefinition, className } = props;
    const viewRegistry = useViewRegistry();
    const allissues = viewRegistry['allissues'];
    const { loading: issueCountLoading, data: issueCount } = useOpDefinitionIssueCount({
        variables: { id: props.opDefinition.id },
    });
    const widget = {
        key: 'last7',
        title: i18n.t('issues'),
        coords: {
            x: 0,
            y: 0,
            w: 200,
            h: 180,
        },
        chart: {
            key: 'issues',
            chartType: ChartType.PIE2D,
            chartVariant: ChartVariant.COUNT_GROUP,
            config: {
                dimension: QFK.ISSUE_STATUS,
            },
        },
        query: {
            type: DataType.ISSUE,
            sortBy: allissues.sortBy,
            sortByDesc: allissues.sortByDesc,
            fields: allissues.fields,
            filters: [
                {
                    queryFieldKey: QFK.OPDEFINITION,
                    id: opDefinition.id,
                    title: opDefinition.title,
                    hidden: true,
                    veryHidden: true,
                },
            ],
            groupBys: [{ queryFieldKey: QFK.ISSUE_STATUS }],
        },
    };
    return (React.createElement(Card, { classes: { root: className } },
        !issueCount && (React.createElement(Vertical, null,
            React.createElement(Text, { variant: "h2" }, widget.title),
            !!issueCountLoading && React.createElement(Dots, { color: Palette.LavendarGrey }),
            !issueCountLoading && (React.createElement(Pane, { padding: true, center: true },
                React.createElement(FakePieChart, null),
                React.createElement("div", { style: { position: 'absolute' } },
                    React.createElement(Text, { centered: true, variant: "h2", color: "grey" }, i18n.t('no-issues-raised'))))))),
        !!issueCount && React.createElement(DashboardWidgetViewer, { isEditable: false, dashboardWidget: widget })));
}
export default IssuesOverviewSection;
function FakePieChart() {
    const fakeData = useMemo(() => range(3).map(x => ({
        label: '',
        color1: Palette.Platinum.main,
        x,
        y: random(5) + 2,
    })), []);
    return useMemo(() => (React.createElement("div", { style: { pointerEvents: 'none' } },
        React.createElement(Pie2D, { hideTotal: true, data: fakeData, width: 240, height: 240 }))), [fakeData]);
}
